import * as Dialog from '@radix-ui/react-dialog'
import { type ApiError } from '../../utils/api-client/api-error.ts'
import { type CodingGuidelinesResponse } from '../../utils/api-client/api-schemas.ts'
import { UploadForm, useUploadForm } from './upload-form.tsx'

export type UploadDrawerProps = {
  organizationId?: string
  onSuccess: (document: CodingGuidelinesResponse, file: File) => unknown
  onCancel: () => unknown
  prefillDisplayName?: string
  onUploadStart?: (displayName: string, file: File) => unknown
  onUploadProgress?: (progressPercent: number) => unknown
  onUploadError?: (error: ApiError | Error) => unknown
}

export const UploadDrawer: React.FC<UploadDrawerProps> = ({
  organizationId,
  onSuccess,
  onCancel,
  prefillDisplayName,
  onUploadStart,
  onUploadProgress,
  onUploadError,
}) => {
  const form = useUploadForm(prefillDisplayName !== undefined ? { displayName: prefillDisplayName } : undefined)

  return (
    <Dialog.Root
      open
      modal={false}
      onOpenChange={open => {
        if (!open) {
          onCancel()
        }
      }}
    >
      <Dialog.Portal>
        <form.AppForm>
          <UploadForm
            organizationId={organizationId}
            onSuccess={onSuccess}
            onCancel={onCancel}
            onUploadStart={onUploadStart}
            onUploadProgress={onUploadProgress}
            onUploadError={onUploadError}
          />
        </form.AppForm>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
